import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { CloseOutlined, EditOutlined, MoreVertOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useRef, useState } from "react"

interface TransferFormProductRowActionsProps {
  productId: number
  hasPallets: boolean
  readOnly?: boolean
  onProductRemove: (productId: number) => void
  onPalletsSelect: (productId: number) => void
}

export const TransferFormProductRowActions: FC<TransferFormProductRowActionsProps> = ({
  productId,
  hasPallets,
  readOnly = false,
  onProductRemove,
  onPalletsSelect,
}) => {
  const anchorElRef = useRef<HTMLDivElement>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleMenuOpen = () => setIsMenuOpen(true)
  const handleMenuClose = () => setIsMenuOpen(false)

  const handleRemove = () => {
    handleMenuClose()
    onProductRemove(productId)
  }

  const handlePalletsSelect = () => {
    handleMenuClose()
    onPalletsSelect(productId)
  }

  return (
    <div ref={anchorElRef}>
      <IconButton
        size='small'
        disabled={readOnly}
        onClick={handleMenuOpen}
        data-testid={`transfer.form-product-row-actions.menu-button-${productId}`}
      >
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isMenuOpen}
        onClose={handleMenuClose}
        data-testid='transfer.form-product-row-actions.menu'
      >
        <MenuItem
          onClick={handlePalletsSelect}
          data-testid={`transfer.form-product-row-actions.select-pallets-button-${productId}`}
        >
          <ListItemIcon>
            <EditOutlined />
          </ListItemIcon>
          <ListItemText primary={hasPallets ? "Edit Pallet Selections" : "Select Pallets"} />
        </MenuItem>
        <MenuItem onClick={handleRemove} data-testid={`transfer.form-product-row-actions.remove-button-${productId}`}>
          <ListItemIcon>
            <CloseOutlined />
          </ListItemIcon>
          <ListItemText primary='Remove Product' />
        </MenuItem>
      </Menu>
    </div>
  )
}
